import { userRequest } from '../requestMethods';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getCatGeofence = async () => {
    return userRequest.get(`${DOMAIN}/api/geofences/cat_geofence`);
};

export const getGeofenceDlog = async () => {
    return userRequest.get(`${DOMAIN}/api/geofences`);
};

export const getGeofenceDlogOne = async (id) => {
    return userRequest.get(`${DOMAIN}/api/geofences/one`, {params: id});
};

export const getGeofenceFalcon = async () => {
    return userRequest.get(`${DOMAIN}/api/geofences/get_geofence_falcon`);
};

export const postGeofenceDlog = async (data) => {
    return userRequest.post(`${DOMAIN}/api/geofences`, data);
};

export const putGeofenceDlog = async (data, idGeofence) => {
    return userRequest.put(`${DOMAIN}/api/geofences?id_geo_dlog=${idGeofence}`, data);
};

//Geofences véhicules
export const getGeofenceVehiculeById = async (idGeofence) => {
    return userRequest.get(`${DOMAIN}/api/geofences/geofence_vehicule`, {
        params: {
            id_geo_dlog : idGeofence
        }
    });
};

export const postGeofenceVehicule = async (data) => {
    return userRequest.post(`${DOMAIN}/api/geofences/geofence_vehicule`, data);
};

export const putGeofenceVehicule = async (data, id_vehicule_geofence) => {
    return userRequest.put(`${DOMAIN}/api/geofences/geofence_vehicule?id_vehicule_geofence=${id_vehicule_geofence}`, data);
};

export const deleteGeofenceVehicule = async (id) => {
    return userRequest.delete(`${DOMAIN}/api/geofences/geofence_vehicule?id=${id}`)
}